import React from 'react'
import Static from '../Components/Component/Static'
import Vision from "../Components/Component/Vision"
import QualityPolicy from '../Components/Component/Quality_Policy'
import Footer from '../Components/Component/Footer'
const About = () => {
  return (
    <div>
       
    <Static />
    <Vision />
   
    <QualityPolicy/>
    
    <Footer />
    </div>
  )
}

export default About